import { isDesktop } from 'react-device-detect'

import { getRandomElementFromArray } from 'utils/utils'

import { responseTypes, studentHeaderCopy } from '../constants'

export const getStudentHeaderCopy = ({ type = responseTypes.CORRECT }) => {
    if (isDesktop) {
        return getRandomElementFromArray(studentHeaderCopy[type])
    }
}

/* this function prepares a comma-seperated list of users who have selected
   a particular option/choice */
export const renderUsers = users => {
    return users.map((fullName, index) => {
        const isLastItem = index + 1 === users.length
        const [firstName] = fullName.split(' ')
        const usersList = isLastItem ? firstName : firstName + ', '
        return usersList
    })
}
